import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useDispatch } from "react-redux";
import { openPrescriptionModal } from "../../../../../../redux/actions/modals";
import MessagesList from "../../../../components/messages/MessagesList";

const counts = [
  {
    value: "1",
    title: "1",
  },
  {
    value: "2",
    title: "2",
  },
  {
    value: "3",
    title: "3",
  },
  {
    value: "4",
    title: "4",
  },
  {
    value: "5",
    title: "5",
  },
  {
    value: "6",
    title: "6",
  },
  {
    value: "7",
    title: "7",
  },
  {
    value: "8",
    title: "8",
  },
  {
    value: "9",
    title: "9",
  },
  {
    value: "10",
    title: "10",
  },
];

const OrderItemDrug = ({
  item,
  getDataOfDrugsOtc,
  fullPreItemExistence,
  makeClear,
}) => {
  const dispatch = useDispatch();
  // console.log("props", item)
  const [checkedExistence, setCheckExistence] = useState(false);
  const [OTCChecked, setOTCChecked] = useState(false);
  const [countDrugInPic, setCountDrugInPic] = useState(0);
  const [countDrugInPharmacy, setCountDrugInPharmacy] = useState(0);
  const [notExistenceItems, setNotExistenseItems] = useState("");
  const [message, setMessage] = useState({
    show: false,
    message: [{ type: "", message: "" }],
  });
  const [messagedes, setMessagedes] = useState({
    show: false,
    message: [{ type: "", message: "" }],
  });
  const [descritionPre, setDescriptionPre] = useState(null);

  const validateExistence = (e) => {
    if (e.target.value > countDrugInPic) {
      setMessage({
        show: true,
        message: [
          {
            type: "danger",
            message:
              "تعداد اقلام موجود در داروخانه نمیتواند از تعداد کل اقلام بیشتر باشد.",
          },
        ],
      });
    } else if (e.target.value === countDrugInPic) {
      setCheckExistence(false);
      fullPreItemExistence(item.id);
    } else {
      setMessage({ ...message, show: false });
      getDataOfDrugsOtc(
        item.id,
        item.description,
        item.tag,
        e.target.value,
        countDrugInPic
      );
    }
  };
  console.log("a");
  useEffect(() => {
    if (makeClear) {
      setOTCChecked(false);
      setCountDrugInPic(0);
      setCheckExistence(false);
      setCountDrugInPharmacy(0);
      setDescriptionPre(null);
    }
  }, [makeClear]);
  return (
    <div className="order-drug-item-holder">
      {item.tag === "OTC" || item.tag === null ? (
        <div className="item-drug-holder">
          <Row className="align-items-start">
            {item.file.originalFileName !== "no-prescription.png" ? (
              <div className="image-holder">
                <img
                  src={item.url}
                  width={100}
                  height={100}
                  alt="prescription-img"
                />
                <button
                  className="show-image-button"
                  onClick={() => {
                    dispatch(openPrescriptionModal(item.url));
                  }}
                >
                  مشاهده
                </button>
              </div>
            ) : null}

            <div className="info-item-drug">
              <span>
                {item.description === "" || item.description === null
                  ? "بدون توضیحات"
                  : item.description}
              </span>
            </div>
          </Row>

          <div className="check-item-holder negative-check">
            <Form.Check
              inline
              checked={OTCChecked}
              onChange={() => {
                // console.log("it is changes")
                const existenceOtc = !OTCChecked ? 0 : 1;
                getDataOfDrugsOtc(
                  item.id,
                  item.description,
                  item.tag,
                  existenceOtc,
                  1
                );
                setOTCChecked(!OTCChecked);
              }}
              label="ندارم"
              type="checkbox"
              name="drugItem"
              id={item.id}
            />
          </div>
        </div>
      ) : (
        <div className="item-drug-holder-prescription">
          <Row className="align-items-center">
            <div className="image-holder">
              <img
                src={item.url}
                width={100}
                height={100}
                alt="prescription-img"
              />
              <button
                className="show-image-button"
                onClick={() => {
                  dispatch(openPrescriptionModal(item.url));
                }}
              >
                مشاهده
              </button>
            </div>
            <div className="check-item-holder">
              <Form.Check
                inline
                checked={checkedExistence}
                onChange={() => {
                  setCheckExistence(!checkedExistence);
                  if (!checkedExistence === true) {
                    fullPreItemExistence(item.id);
                  }
                  setDescriptionPre(null);
                }}
                label="تمام موارد نسخه موجود نیست"
                type="checkbox"
                name="prescriptionItem"
                id={item.id}
              />
            </div>
          </Row>
          {checkedExistence && (
            <div className="items-select-count">
              <Row className="mb-0">
                <Col sm={12} lg={6} className="mb-3">
                  <div className="drug-existence-holder">
                    <label>تعداد اقلام موجود در تصویر یا نسخه</label>
                    <select
                      className="form-control"
                      onChange={(e) => {
                        // console.log("change",e.target.value)
                        getDataOfDrugsOtc(
                          item.id,
                          item.description,
                          item.tag,
                          countDrugInPharmacy,
                          e.target.value
                        );
                        setCountDrugInPic(e.target.value);
                      }}
                    >
                      {counts.map((count, index) => {
                        return (
                          <option key={index} value={count.value}>
                            {count.title}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </Col>
                <Col sm={12} lg={6} className="mb-3">
                  <div className="drug-existence-holder">
                    <label>تعداد اقلام موجود در داروخانه</label>
                    <select
                      className="form-control"
                      onChange={(e) => {
                        validateExistence(e);
                        // getDataOfDrugsOtc(item.id, item.description, item.tag,e.target.value, countDrugInPic )
                        setCountDrugInPharmacy(e.target.value);
                      }}
                    >
                      {counts.map((count, index) => {
                        return (
                          <option key={index} value={count.value}>
                            {count.title}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {message.show && <MessagesList messages={message.message} />}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    className="not-existence-items"
                    controlId="reasons"
                  >
                    <Form.Label>
                      لیست اقلام ناموجود خود را وارد نمایید (الزامی)
                    </Form.Label>
                    <Form.Control
                      required
                      as="textarea"
                      placeholder="لیست اقلام ناموجود"
                      value={descritionPre}
                      onChange={(e) => {
                        getDataOfDrugsOtc(
                          item.id,
                          e.target.value,
                          item.tag,
                          countDrugInPharmacy,
                          countDrugInPic
                        );
                        setDescriptionPre(e.target.value);
                      }}
                      rows={3}
                    />
                    {messagedes.show && (
                      <MessagesList messages={message.message} />
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OrderItemDrug;
